import { isChromeBrowser } from './browser';

export const BROWSER_RECOMMENDATION_MESSAGE =
  'For the best experience, please use Google Chrome on a laptop or desktop device.';

export const BROWSER_RECOMMENDATION_DISMISSAL_KEY = 'kl_browser_recommendation_dismissed_at';

export const BROWSER_RECOMMENDATION_DISMISSAL_DAYS = 30;

/** CSS value applied to :root when the banner is visible (includes safe-area). */
export const BROWSER_RECOMMENDATION_BANNER_HEIGHT =
  'calc(48px + env(safe-area-inset-top, 0px))';

const DISMISSAL_MS = BROWSER_RECOMMENDATION_DISMISSAL_DAYS * 24 * 60 * 60 * 1000;

/**
 * @returns {boolean} True if user dismissed the banner within the retention window.
 */
export function isBrowserRecommendationDismissed() {
  if (typeof window === 'undefined') return false;

  try {
    const raw = window.localStorage.getItem(BROWSER_RECOMMENDATION_DISMISSAL_KEY);
    if (!raw) return false;

    const dismissedAt = Number.parseInt(raw, 10);
    if (!Number.isFinite(dismissedAt)) {
      window.localStorage.removeItem(BROWSER_RECOMMENDATION_DISMISSAL_KEY);
      return false;
    }

    return Date.now() - dismissedAt < DISMISSAL_MS;
  } catch {
    return false;
  }
}

/**
 * Persist dismissal timestamp for {@link BROWSER_RECOMMENDATION_DISMISSAL_DAYS} days.
 */
export function dismissBrowserRecommendation() {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(BROWSER_RECOMMENDATION_DISMISSAL_KEY, String(Date.now()));
  } catch {
    // Storage unavailable — banner may reappear on reload; non-critical.
  }
}

/**
 * @param {boolean} isMobileViewport - Viewport width < 768px
 * @returns {boolean}
 */
export function shouldShowBrowserRecommendation(isMobileViewport) {
  if (isBrowserRecommendationDismissed()) return false;
  if (isMobileViewport) return true;
  if (!isChromeBrowser()) return true;
  return false;
}

/**
 * @param {boolean} visible
 * @returns {string} CSS length for layout offset
 */
export function getBrowserRecommendationBannerOffset(visible) {
  return visible ? BROWSER_RECOMMENDATION_BANNER_HEIGHT : '0px';
}
